import { render, staticRenderFns } from "./PollResultsModal.vue?vue&type=template&id=1d715ae2"
import script from "./PollResultsModal.vue?vue&type=script&lang=js"
export * from "./PollResultsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports